import _ from 'lodash'
import LabeledToggle from 'scoreboard/components/labeled-toggle'

/**
 * A simple labeled toggle configured with the options for DataSourceType
 * (ie Basic vs Calculated)
 */
const DataSourceTypeToggle = LabeledToggle.extend({
	/**
	 * See labeled-toggle.js for options. This uses defaults appropriate for
	 * DataSourceType selection, but any options can be overridden.
	 */
	initialize: function(options = {}) {
		LabeledToggle.prototype.initialize.call(this, _.extend({
			name: 'dataSourceType',
			options: [{
				value: 'basic',
				label: 'common.basic'
			}, {
				value: 'calculated',
				label: 'scorecards.node.metric.updateType.calculated'
			}]
		}, options))
	}
})

export default DataSourceTypeToggle

DataSourceTypeToggle.__filename__ = 'components/data-source-selector/data-source-type-toggle.js'
